<div *ngIf="visible" class="karte-wrapper"
	[class.panel-open]="!projectPanelCollapsed && (aus.isAuthenticated.value || oms.offlineMode() || ps.project()) && !showLayersControl && !restrictedMode"
	[class.panel-collapsed]="projectPanelCollapsed && (aus.isAuthenticated.value || oms.offlineMode() || ps.project()) && !showLayersControl && !restrictedMode">
	<div class="karte"
		leaflet
		[leafletOptions]="options"
		(leafletMapReady)="onMapReady($event)"
		(leafletMapZoomEnd)="onMapZoomEnd($event)"
		(leafletMapMoveEnd)="onMapZoomEnd($event)"
		#mapDiv>
	</div>

	<bp-map-controls *ngIf="!restrictedMode"
		[zoomLevel]="mapStatus?.zoom || 0"
		[zoomToWindowActive]="mapSelectionService.zoomToWindowActive"
		[selectionMode]="mapSelectionService.selectionMode"
		[selectionCount]="selectionService.count()"
		[polygonPoints]="mapSelectionService.selectionPoints.length"
		[canCreatePoint]="drawingService.canCreateNewPoint()"
		[showDrawControls]="drawingService.showDrawControls()"
		[networkAvailable]="oms.userOfflineMode() || oms.networkOnline()"
		[drawEnabled]="drawingService.drawEnabled"
		[drawPolygonPoints]="drawingService.drawPolygonPoints"
		[freehandEnabled]="drawingService.freehandEnabled"
		[lineEnabled]="drawingService.lineEnabled"
		[lineFreehandEnabled]="drawingService.lineFreehandEnabled"
		[editEnabled]="drawingService.editEnabled"
		[deleteEnabled]="drawingService.deleteEnabled"
		[gpsTrackingPolygonEnabled]="drawingService.gpsTrackingPolygonEnabled"
		[gpsTrackingLineEnabled]="drawingService.gpsTrackingLineEnabled"
		[hasDrawnPolygon]="drawingService.hasDrawnPolygon"
		[hasDrawnLine]="drawingService.hasDrawnLine"
		[newPointOnMapActive]="drawingService.newPointOnMapActive"
		[wmsInfoActive]="wmsInfoService.wmsInfoActive"
		[hasVisibleWmsLayers]="hasVisibleWmsLayers"
		[filteredCount]="filteredCount"
		(zoomIn)="map.zoomIn()"
		(zoomOut)="map.zoomOut()"
		(gpsHome)="onGpsHome()"
		(fitBounds)="onFitBounds()"
		(zoomToSelection)="onZoomToSelection()"
		(zoomToFilter)="onZoomToFilter()"
		(zoomToWindow)="mapSelectionService.onZoomToWindow()"
		(selectionModeChange)="mapSelectionService.onSelectionModeChanged($event)"
		(finishPolygon)="mapSelectionService.finishPolygonSelection()"
		(clearSelection)="clearSelection()"
		(selectFiltered)="selectFiltered()"
		(printSelection)="printSelection()"
		(deleteSelection)="deleteSelection()"
		(newPointAtLocation)="drawingService.onNewPointAtLocation()"
		(newPointOnMap)="drawingService.onNewPointOnMap()"
		(toggleDraw)="drawingService.onToggleDraw()"
		(finishDrawPolygon)="drawingService.onFinishDrawPolygon()"
		(toggleFreehand)="drawingService.onToggleFreehand()"
		(toggleLine)="drawingService.onToggleLine()"
		(toggleLineFreehand)="drawingService.onToggleLineFreehand()"
		(toggleGpsTrackingPolygon)="drawingService.onToggleGpsTrackingPolygon()"
		(toggleGpsTrackingLine)="drawingService.onToggleGpsTrackingLine()"
		(stopGpsTracking)="drawingService.onStopGpsTracking()"
		(editDraw)="drawingService.onEditDraw()"
		(deleteDraw)="drawingService.onDeleteDraw()"
		(confirmEdit)="drawingService.onConfirmEdit()"
		(cancelEdit)="drawingService.onCancelEdit()"
		(finishDrawMode)="drawingService.onFinishDrawMode()"
		(toggleWmsInfo)="onToggleWmsInfo()"
		(deactivateAllTools)="onDeactivateAllTools()">
	</bp-map-controls>

  <!-- Project Manager Panel (Angular-basiert statt Leaflet-Control) -->
  @if ((aus.isAuthenticated.value || oms.offlineMode() || ps.project()) && !showLayersControl && !restrictedMode) {
    <div class="project-panel" [class.collapsed]="projectPanelCollapsed">
      <div class="panel-header">
        <button class="panel-collapse-btn"
                (click)="toggleProjectPanel(); $event.stopPropagation()"
                (touchend)="toggleProjectPanel(); $event.stopPropagation(); $event.preventDefault()"
                [title]="projectPanelCollapsed ? 'Projektmenü öffnen' : 'Projektmenü schließen'">
          <i class="bi" [class.bi-chevron-left]="projectPanelCollapsed" [class.bi-chevron-right]="!projectPanelCollapsed"></i>
        </button>
        <span class="panel-title" *ngIf="!projectPanelCollapsed">Projektmenü</span>
      </div>
      @if (!projectPanelCollapsed) {
        <div class="panel-content">
          <bp-project-manager></bp-project-manager>
        </div>
      }
      @if (projectPanelCollapsed) {
        <span class="panel-collapsed-label"
              (click)="toggleProjectPanel(); $event.stopPropagation()"
              (touchend)="toggleProjectPanel(); $event.stopPropagation(); $event.preventDefault()">Projektmenü</span>
      }
    </div>
  }

  <!-- Layers-only Panel für eingebettete Karten -->
  @if (showLayersControl && !restrictedMode) {
    <div class="project-panel" #layersPanel
         [style.top.px]="layersPanelPosition.y"
         [style.left.px]="layersPanelPosition.x"
         [style.right]="layersPanelPosition.x !== null ? 'auto' : '10px'">
      <div class="panel-header"
           (mousedown)="onPanelDragStart($event, layersPanel)"
           (touchstart)="onPanelTouchStart($event, layersPanel)">
        <button class="panel-toggle" (click)="layersPanelCollapsed = !layersPanelCollapsed"
                (touchend)="$event.stopPropagation()"
                [title]="layersPanelCollapsed ? 'Layer öffnen' : 'Layer schließen'">
          <i class="bi bi-layers"></i>
        </button>
      </div>
      @if (!layersPanelCollapsed) {
        <div class="panel-content">
          <bp-project-manager [layersOnly]="true"></bp-project-manager>
        </div>
      }
    </div>
  }

  <!-- Reposition-Modus: Fadenkreuz + Buttons -->
  @if (repositionMode) {
    <div class="reposition-overlay">
      <div class="reposition-crosshair">
        <div class="crosshair-h"></div>
        <div class="crosshair-v"></div>
        <div class="crosshair-circle"></div>
      </div>
      <div class="reposition-banner">
        <i class="bi bi-arrows-move me-2"></i>Karte verschieben, um neue Position zu setzen
      </div>
      <div class="reposition-buttons">
        <button class="btn btn-success btn-sm" (click)="onRepositionConfirm()">
          <i class="bi bi-check-lg me-1"></i>Übernehmen
        </button>
      </div>
    </div>
  }

  <!-- Punkt-Kontextmenü (Touchoptimiert) -->
  @if (contextMenuMarker && contextMenuPosition && !restrictedMode) {
    <div class="point-context-overlay" (click)="closeContextMenu()">
      <div class="point-context-menu"
           [style.left.px]="contextMenuPosition.x"
           [style.top.px]="contextMenuPosition.y"
           (click)="$event.stopPropagation()">
        <div class="context-menu-header">
          <span class="context-menu-title">{{ contextMenuMarker.label || 'Punkt' }}</span>
          <button class="context-menu-close" (click)="closeContextMenu()">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <div class="context-menu-info" *ngIf="aus.isAuthenticated.value && !aus.amI('gast') && (contextMenuMarker.author || contextMenuMarker.date)">
          <span *ngIf="contextMenuMarker.author">{{ contextMenuMarker.author }}</span>
          <span *ngIf="contextMenuMarker.date">{{ formatDate(contextMenuMarker.date) }}</span>
        </div>
        <div class="context-menu-items">
          <button class="context-menu-item" (click)="onContextMenuOpen()">
            <i class="bi bi-file-earmark-text"></i>
            <span>Öffnen</span>
          </button>
          <button class="context-menu-item" [class.selected]="selectionService.isSelected(contextMenuMarker.id)" (click)="onContextMenuToggleSelect()">
            <i class="bi" [class.bi-check-square-fill]="selectionService.isSelected(contextMenuMarker.id)" [class.bi-square]="!selectionService.isSelected(contextMenuMarker.id)"></i>
            <span>{{ selectionService.isSelected(contextMenuMarker.id) ? 'Abwählen' : 'Zur Auswahl' }}</span>
          </button>
          <button class="context-menu-item" *ngIf="canAssignToProject()" (click)="onContextMenuAssignToProject()">
            <i class="bi bi-folder-plus"></i>
            <span>Zum Projekt</span>
          </button>
          <div class="context-menu-divider" *ngIf="canRemoveFromProject() || canDeletePoint()"></div>
          <button class="context-menu-item danger" *ngIf="canRemoveFromProject()" (click)="onContextMenuRemoveFromProject()">
            <i class="bi bi-folder-minus"></i>
            <span>Aus Projekt</span>
          </button>
          <button class="context-menu-item danger" *ngIf="canDeletePoint()" (click)="onContextMenuDelete()">
            <i class="bi bi-trash"></i>
            <span>Löschen</span>
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Polygon-Kontextmenü -->
  @if (contextMenuPolygon && contextMenuPolygonPosition && !restrictedMode) {
    <div class="point-context-overlay" (click)="closePolygonContextMenu()">
      <div class="point-context-menu"
           [style.left.px]="contextMenuPolygonPosition.x"
           [style.top.px]="contextMenuPolygonPosition.y"
           (click)="$event.stopPropagation()">
        <div class="context-menu-header">
          <span class="context-menu-title">{{ contextMenuPolygon.label || 'Fläche' }}</span>
          <button class="context-menu-close" (click)="closePolygonContextMenu()">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <div class="context-menu-items">
          <button class="context-menu-item" (click)="onPolygonContextMenuOpen()">
            <i class="bi bi-file-earmark-text"></i>
            <span>Öffnen</span>
          </button>
          <button class="context-menu-item" (click)="onPolygonContextMenuHighlight()">
            <i class="bi bi-bounding-box"></i>
            <span>Markieren</span>
          </button>
        </div>
      </div>
    </div>
  }

  <!-- WMS Info Panel -->
  @if (wmsInfoService.results().length > 0 || wmsInfoService.loading()) {
    <div class="point-context-overlay" (click)="wmsInfoService.closeResults()">
      <div class="wms-info-panel"
           [style.left.px]="wmsInfoService.clickPosition()?.x"
           [style.top.px]="wmsInfoService.clickPosition()?.y"
           (click)="$event.stopPropagation()">
        <div class="context-menu-header" style="cursor: move;"
             (mousedown)="onWmsInfoDragStart($event)"
             (touchstart)="onWmsInfoDragStart($event)">
          <span class="context-menu-title">Layer-Info</span>
          <button class="context-menu-close" (click)="wmsInfoService.closeResults()">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <div class="wms-info-content">
          @if (wmsInfoService.loading()) {
            <div class="wms-info-loading">
              <div class="spinner-border spinner-border-sm" role="status"></div>
              <span>Daten werden abgefragt...</span>
            </div>
          }
          @for (result of wmsInfoService.results(); track result.layerTitle) {
            <div class="wms-info-layer">
              <div class="wms-info-layer-title">{{ result.layerTitle }}</div>
              @if (result.error) {
                <div class="wms-info-error">{{ result.error }}</div>
              } @else {
                @if (objectKeys(result.data).length === 0) {
                  <div class="wms-info-empty">Keine Daten an dieser Position</div>
                } @else {
                  <table class="wms-info-table">
                    @for (key of objectKeys(result.data); track key) {
                      <tr>
                        <td class="wms-info-key">{{ key }}</td>
                        <td class="wms-info-value">{{ result.data[key] }}</td>
                      </tr>
                    }
                  </table>
                }
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
